import * as React from 'react'
import type { JSX } from 'react'

import { useCalendarContext } from './context'
import { useScrollToCurrentHour } from './hooks/useScrollToCurrentHour'
import { Hour } from './Hour'
import type { CalendarBlockData } from './types'

type WeekProps = {
  hours: CalendarBlockData[][]
  scrollContainerRef: React.RefObject<HTMLDivElement>
}

const Week = ({ hours, scrollContainerRef }: WeekProps): JSX.Element => {
  const { loading, currentTime, scrollTarget } = useCalendarContext()
  const currentHourRef = useScrollToCurrentHour(scrollContainerRef)
  const scrollHour = scrollTarget ?? currentTime.now

  return (
    <>
      {hours.map((hourRows, columnIndex) => {
        return (
          <tr
            key={`weekly-row-${hourRows[0].start.toString()}`}
            data-testid={`weekly-row-${hourRows[0].start.toString()}`}
          >
            {hourRows.map((hour, index) => {
              const isScrollHour =
                hour.start.hour === scrollHour?.hour &&
                hour.start.day === scrollHour?.day &&
                hour.start.month === scrollHour?.month &&
                hour.start.year === scrollHour?.year
              return (
                <Hour
                  key={hour.start.toString()}
                  index={columnIndex}
                  loading={loading}
                  hour={hour}
                  showLabel={index === 0}
                  ref={isScrollHour ? currentHourRef : null}
                />
              )
            })}
          </tr>
        )
      })}
    </>
  )
}

const memoWeek = React.memo(Week)
export { memoWeek as Week }
